import * as React from 'react';
import { SVGProps } from 'react';

const SvgTwitter = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 6.625c-.626.284-1.3.471-1.999.561a3.494 3.494 0 0 0 1.528-1.934 7.021 7.021 0 0 1-2.21.853C16.677 5.406 15.775 5 14.751 5c-1.91 0-3.47 1.56-3.47 3.486 0 .276.033.544.089.796a9.91 9.91 0 0 1-7.184-3.641 3.445 3.445 0 0 0-.471 1.747 3.43 3.43 0 0 0 1.552 2.893 3.448 3.448 0 0 1-1.585-.406v.024a3.49 3.49 0 0 0 2.795 3.421 3.44 3.44 0 0 1-1.568.057 3.48 3.48 0 0 0 3.25 2.422 6.922 6.922 0 0 1-4.331 1.495c-.276 0-.553-.016-.829-.049a9.873 9.873 0 0 0 5.347 1.568c6.403 0 9.922-5.314 9.922-9.922 0-.154 0-.301-.008-.455a6.96 6.96 0 0 0 1.739-1.812z" />
  </svg>
);

export default SvgTwitter;
